import { Deserializable } from '../protocols/deserializable';
import { FundType } from '../transactions/fund-type';
import { DonutChartData } from '../../views/shared/components/donut-chart/donut-chart-data';

export class InvestmentInstructionSubmissionAccountRebalancingData implements Deserializable {
  public fundId!: number;
  public fund!: FundType;
  public percentage!: number;
  public amount!: number;

  public asDonutChartData(): DonutChartData {
    return {
      label: this.fund.name,
      percentage: this.percentage.toFixed(2),
      color: this.fund.colour,
      amount: this.amount
    };
  }

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (!!this.fund) {
      this.fund = Deserialize.instanceOf(FundType, this.fund);
    }
  }
}
